import type { LandingResults } from 'src/common/types/api/v4/search/v1/landing';
import { journalPages, listingTypes, reviews } from './data/pageContent';
import topListings from './data/topListings';
import topDestinationSlugs from './data/topDestinationSlugs';

const landingPageContent = {
  journal_pages: journalPages,
  listing_types: listingTypes,
  reviews,
} as LandingResults;

export {
  landingPageContent,
  topDestinationSlugs,
  topListings,
};
